module.exports = __webpack_public_path__ + "img/pro_one_6.56504eb4.jpg";